module.exports = __webpack_public_path__ + "img/options-glassthickness.e168b6e8.svg";